var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveChat = function SvgLiveChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.171 11.695c.37 0 .627.306.627.651v2.478l5.404-3.065a.504.504 0 0 1 .332-.114l5.245.05V1.302H1.255v10.393h2.916Zm-.628 4.24v-2.938H.627a.634.634 0 0 1-.627-.65V.65C0 .307.295 0 .627 0h15.78c.332 0 .59.307.59.651v5.346h6.369c.369 0 .627.307.627.651v8.827c0 .383-.258.651-.627.651h-2.369v2.222c0 .383-.258.651-.627.651-.11 0-.259-.038-.333-.114l-4.645-2.759h-4.895c-.37 0-.628-.268-.628-.65v-2.031l-5.366 3.026c-.074.077-.184.115-.332.115-.332 0-.628-.306-.628-.651Zm16.199-.46c0-.344.295-.65.628-.65h2.405V7.298h-5.778v5.047c0 .383-.258.651-.59.651h-5.32v1.827h4.453c.148 0 .258.038.369.115l3.833 2.337v-1.8Z",
    clipRule: "evenodd"
  })));
};
export default SvgLiveChat;